import { useEffect, useState, createContext, useContext } from 'react';
import DefaultProfileAvatar from 'images/DefaultProfileAvatar.png';
import { selectAppConfig } from 'store/initialize';
import { useSelector } from 'react-redux';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { useAuth0 } from '@auth0/auth0-react';

const defaultState = {
  profileImageUrl          : '',
  handleSetProfileImageUrl : undefined,
  handleSetHeaderImageUrl  : undefined,
};

const ProfileImageContext = createContext(defaultState);

export const ProfileImageContextProvider = ({ children }) => {
  const { user } = useAuth0();
  const { userMetaData } = useGetPersonAndAttributes();
  const [profileImageUrl, setProfileImageUrl] = useState('');
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [headerImageUrl, setHeaderImageUrl] = useState('');
  const { azureStorageBlobToken: encodedAzureStorageBlobToken } =
    useSelector(selectAppConfig());
  const azureStorageBlobToken = decodeURIComponent(
    encodedAzureStorageBlobToken
  );

  const handleSetProfileImageUrl = (url) => {
    setProfileImageUrl(url);
  };

  const handleSetHeaderImageUrl = (url) => {
    setHeaderImageUrl(url);
  };

  useEffect(() => {
    const getProfileImage = async () => {
      const picture = userMetaData?.picture ?? user?.picture;
      if (picture?.includes('pkdfpkd')) {
        fetch(`${picture}?${azureStorageBlobToken}`)
          .catch((e) => {
            setProfileImageUrl('');
          })
          .then(() => {
            const url = !picture.includes('pkdfpkd')
              ? DefaultProfileAvatar
              : `${picture}?${azureStorageBlobToken}`;
            setProfileImageUrl(url);
            setHeaderImageUrl(url);
          });
      }
    };
    getProfileImage();
  }, [userMetaData?.picture, user?.picture]);

  useEffect(() => {
    const isRemoteUrl = profileImageUrl.includes('pkdfpkd');
    const urlQuery = isRemoteUrl
      ? `&date=${new Date().getTime()}`
      : `?${new Date().getTime()}`;
    const imageUrl =
      profileImageUrl === ''
        ? DefaultProfileAvatar
        : profileImageUrl.includes(window.location.origin)
          ? profileImageUrl
          : `${profileImageUrl}${urlQuery}}`;
    setUploadedImageUrl(imageUrl);
  }, [profileImageUrl]);

  const contextValues = {
    profileImageUrl,
    uploadedImageUrl,
    headerImageUrl,
    handleSetProfileImageUrl,
    handleSetHeaderImageUrl,
  };

  return (
    <ProfileImageContext.Provider
      value={contextValues}>
      {children}
    </ProfileImageContext.Provider>
  );
};

export const useProfileImage = () => useContext(ProfileImageContext);
